<template>
	<div class="flex flex-col lg:h-full" v-if="isUserAllowedInLevel1">
		<router-view />
		<!-- router view for PageModal -->
		<BaseHeader :title="$t('manufacturer_model_list').toString()" />
		<div class="flex flex-grow relative main">
			<div class="w-full mr-12 lg:mr-0">
				<CardWrapper>
					<BaseCard
						:title="$t('manufacturer_list').toString()"
						:is-toggleable="false"
						@clickEdit="$router.push({ name: 'vehicles.manufacturer' })"
						:is-editable="true"
					>
						<template #icons>
							<button @click="$router.push({ name: 'vehicles.manufacturer.new' })" :title="$t('add_manufacturer')">
								<font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
							</button>
						</template>
						<div class="mb-2">
							<div class="break-all leading-none max-w-full">
								<label>{{ $t('manufacturer_total_input') }} {{ manufacturerAll }}</label>
							</div>
						</div>
						<div class="mb-2">
							<div class="break-all leading-none max-w-full">
								<label>{{ $t('manufacturer_new_input') }} {{ manufacturerUnchecked }}</label>
							</div>
						</div>
					</BaseCard>
					<BaseCard
						:title="$t('model_list').toString()"
						:is-toggleable="false"
						@clickEdit="$router.push({ name: 'vehicles.models' })"
						:is-editable="true"
					>
						<template #icons>
							<button @click="$router.push({ name: 'vehicles.model.new' })" :title="$t('add_model')">
								<font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
							</button>
						</template>
						<div class="mb-2">
							<div class="break-all leading-none max-w-full">
								<label>{{ $t('model_total_input') }} {{ modelsAll }}</label>
							</div>
						</div>
						<div class="mb-2">
							<div class="break-all leading-none max-w-full">
								<label>{{ $t('model_new_input') }} {{ modelsUnchecked }}</label>
							</div>
						</div>
					</BaseCard>
				</CardWrapper>
			</div>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import BaseCard from '@/components/damagecases/forms/BaseCard';
import { VehiclesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import CardWrapper from '@/components/damagecases/forms/CardWrapper';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'VehicleOverview',
	components: {
		Forbidden,
		CardWrapper,
		BaseCard,
		BaseHeader,
	},
	mixins: [Authentication],
	data() {
		return {
			manufacturerAll: [],
			manufacturerUnchecked: [],
			modelsAll: [],
			modelsUnchecked: [],
		};
	},
	methods: {
		loadManufacturerAndModelStats() {
			VehiclesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.vehiclesManufacturerandmodelstatsGet()
				.then(response => {
					this.manufacturerAll = response.data.manufacturerAll;
					this.manufacturerUnchecked = response.data.manufacturerUnchecked;
					this.modelsAll = response.data.modelsAll;
					this.modelsUnchecked = response.data.modelsUnchecked;
				});
		},
	},
	watch: {
		$route: {
			immediate: true,
			deep: true,
			handler() {
				if (this.isUserAllowedInLevel1) {
					this.loadManufacturerAndModelStats();
				}
			},
		},
	},
};
</script>

<style scoped></style>
